// import dos componentes
import { useTranslation } from "react-i18next";
import FixedTable from "../../../Layout/Components/Table/FixedTable";
import Loading from "../../../Layout/Components/Loading";
import { Row } from "react-bootstrap";
import { usePaymentValues } from "../../../../Hook/Financial/usePaymentValues";

export default function PaymentValues({idClient}) {
    const { t } = useTranslation();
    const { prices, loading, fetchPrices } = usePaymentValues({idClient});

    // List data from the users table
    const tableColumns = [
        {
            field: "id",
            label: "#",
            type: "number",
        },
        {
            field: "description",
            label: t("financial.prices.table.description"),
            type: "string",
        },
        {
            field: "is_active",
            label: t("financial.prices.table.is_active"),
            type: "boolean",
        },
        {
            field: "type_price",
            value: {
                1: t(
                    "financial.prices.table.type-price.time"
                ),
                2: t(
                    "financial.prices.table.type-price.line"
                ),
            },
            label: t(
                "financial.prices.table.type-price.label"
            ),
            type: "string",
        },
        {
            field: "game.description",
            label: t("financial.prices.table.game"),
            type: "string",
        },
        {
            field: "allow_discount",
            label: t("financial.prices.table.allows-discount"),
            type: "boolean",
        },
        {
            field: "days_use_label",
            label: t("financial.prices.table.days-use.label"),
            type: "string",
        },
        {
            field: "hour_init",
            label: t("financial.prices.table.hour-init"),
            type: "time",
        },
        {
            field: "hour_end",
            label: t("financial.prices.table.hour-end"),
            type: "time",
        },
        {
            field: "price",
            label: t("financial.prices.table.value"),
            type: "currency",
        },
        {
            field: "created_user.name",
            label: t("financial.prices.table.create_user"),
            type: "string",
        },
        {
            field: "created_at",
            label: t("financial.prices.table.create_at"),
            type: "date-time",
        },
        {
            field: "updated_user.name",
            label: t("financial.prices.table.update_user"),
            type: "string",
        },
        {
            field: "updated_at",
            label: t("financial.prices.table.update_at"),
            type: "date-time",
        },
    ];

    return (
        <>            
            <Row className="account-receivable-price" style={{ "--screen-header": "56px" }}>
                {loading ? (
                    <Loading />
                ) : (
                    <FixedTable
                        table="clients_prices"
                        columns={tableColumns}
                        data={prices}
                        empty={t("financial.prices.table.empty")}
                        reload={fetchPrices}
                    />
                )}
            </Row>
        </>
    );
}
